import { useQuery } from '@tanstack/react-query'
import { sportsRepository } from '../repositories/sportsRepository'

export const useSports = () => {
  return useQuery({
    queryKey: ['sports', 'active'],
    queryFn: () => sportsRepository.fetchActiveSports(),
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}
